import React , {useEffect , useState} from "react";

import { queryClient } from "../../../state/queryClient";

import { axios_cabinetscompagnies_update , axios_cabinetscompagnies_create } from "../../../axios/axios_cabinetscompagnies";

import Button from "../../Buttons/Button";

import './ContactsCompagnie.scss';
function ContactsCompagnie({infoscompagnie,selectedcompagnie}){

    const [infoscontacts, setInfoscontacts] = useState({...infoscompagnie}) ;
    const [loading , setLoading] = useState(false) ;
    const [alertinfosenreg , setAlertinfosenreg] = useState(false) ;

    useEffect(()=>{setInfoscontacts(infoscompagnie)},[infoscompagnie])

    const handlechange = (e)=>{  setInfoscontacts({...infoscontacts,[e.target.id]:e.target.value})}

    const disablebtn = !infoscontacts?.email_inspecteur || !infoscontacts?.codecourtier
    

    const updatecompagniecourtier = async()=>{ 
        setLoading(true)
       if(infoscompagnie?.id){await axios_cabinetscompagnies_update(infoscontacts)}
       else{await axios_cabinetscompagnies_create({...infoscontacts,compagnie:selectedcompagnie.compagnie,compagnie_mini:selectedcompagnie.compagnie_mini,id_compagnie:selectedcompagnie.id_compagnie})}

       queryClient.invalidateQueries({ queryKey: ['datascourtiercompagnies']})  ; 
       // TRACKER !!!!
       setLoading(false) ;
       setAlertinfosenreg(true) ;
       setTimeout(()=>{setAlertinfosenreg(false) ;}, 5000)
    }

    return(<div className="container_formcontactcompagnie">
             <div className="titrecompagnie">Autorisation {infoscompagnie?.compagnie}</div>
             <div className="soustitrecompagnie">Autorisations et formules</div><br/>

             <div  className="compagnielabelinput" >
                <div className="inputtextelabel">Code courtier</div>
                <input id='codecourtier' type="text"  autoComplete="off"     onChange={handlechange} value={infoscontacts?.codecourtier||''}  />
            </div>
            <div className="lineinfocourtier" >
             <div  className="compagnielabelinput" >
                <div className="inputtextelabel">Votre inspecteur</div>
                <input id='nomprenom_inspecteur' type="text"  autoComplete="off"     onChange={handlechange} value={infoscontacts?.nomprenom_inspecteur||''}  />
            </div>
            <div  className="compagnielabelinput" >
                <div className="inputtextelabel">Email inspecteur</div>
                <input id='email_inspecteur' type="text"  autoComplete="off"     onChange={handlechange} value={infoscontacts?.email_inspecteur||''}  />
            </div>
            <div  className="compagnielabelinput last" >
                <div className="inputtextelabel">Téléphone inspecteur</div>
                <input id='tel_inspecteur' type="text"  autoComplete="off"     onChange={handlechange} value={infoscontacts?.tel_inspecteur||''}  />
            </div>
            </div>
            <Button texte='Confirmer' 
                    color='bouton_color_orange' 
                    disable={disablebtn}
                    loading={loading}
                    size='bouton_size_normal' 
                    onclick={updatecompagniecourtier} />
             {alertinfosenreg &&   <span className="alertinfosenreg">Les informations ont été enregistrées.</span>}
            <br/><br/>

    </div>)

}


export default ContactsCompagnie